import { FormikCheckbox } from '@febos-io/design';
import { InputProps } from "./types";

export function FilterListCheck({
  name,
  config
}:InputProps) {
  return (
    config?.options?.map((option) => (
      <FormikCheckbox
        value={option?.value}
        label={option?.label}
        key={option?.value}
        name={name}
      />
    ))
  );
}

export default FilterListCheck;
